module.exports = __webpack_public_path__ + "static/1.2.A. CAIAN RANDARE 3-c8c07fa8f66e5fa74d80f756e2cffe0a.jpg";